document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("onboarding")) {
        $("#onboarding .close").click(function (e) {
            e.preventDefault();
            $.ajax({
                url: "/complete-onboarding",
                type: "POST",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                },
                success: function success(response) {
                    $("#onboarding").remove();
                }
            });
        });
        $("#onboarding a:not(.close)").click(function (e) {
            e.preventDefault();
            var href = $(this).attr("href");
            $.ajax({
                url: "/complete-onboarding",
                type: "POST",
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                },
                success: function success(response) {
                    window.location = href;
                }
            });
        });
    }
});
